import cs from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileHeading.scss'

interface WixMobileHeadingProps {
  dataHook?: string
  textAlign?: 'left' | 'center' | 'right'
}

export const WixMobileHeading: FC<WixMobileHeadingProps> = ({ children, dataHook, textAlign }) => (
  <h1
    className={cs(s.heading, { [s.left]: textAlign === 'left', [s.right]: textAlign === 'right' })}
    data-hook={dataHook}
  >
    {children}
  </h1>
)
